import anime from 'animejs'
import { IS_MOBILE } from '../constants/const'
import { LENIS_SCROLL_GLOBAL } from '../scroll'
import { onSelect } from '../utils/dom'
import { onScrollAnime } from './animations'

const INIT_ANIME = {
  solution1: onSelect('.bl-solution-points-solution.solution--550859'),
  solution2: onSelect('.bl-solution-points-solution.solution--550869'),
  solution3: onSelect('.bl-solution-points-solution.solution--550870'),
  solution4: onSelect('.bl-solution-points-solution.solution--550871'),
  solution5: onSelect('.bl-solution-points-solution.solution--550872'),
  solution6: onSelect('.bl-solution-points-solution.solution--550873'),
  solution7: onSelect('.bl-solution-points-solution.solution--550874'),
}

const PROPS_ANIME = {
  opacity1: { value: 0, delay: anime.random(1600, 2000), duration: anime.random(3000, 4000), easing: 'easeInOutBack' },
  scale1: { value: 0.7, duration: anime.random(3000, 4000), easing: 'easeInOutSine' },
  translateY1: { value: 380, duration: anime.random(3000, 4000), easing: 'easeInOutSine' },
  translateY2: { value: 480, duration: anime.random(3000, 5000), easing: 'easeInOutSine' },
  translateX1: { value: anime.random(100, 150), duration: anime.random(3000, 4000), easing: 'easeInOutSine' },
  translateX2: { value: -anime.random(100, 150), duration: anime.random(3000, 4000), easing: 'easeInOutSine' },
  translateX2: { value: -anime.random(100, 150), duration: anime.random(3000, 4000), easing: 'easeInOutSine' },
}

const FUNNEL_ANIME = anime
  .timeline({
    loop: false,
    autoplay: false,
    duration: 5000,
    easing: 'easeInOutBack',
    delay: function (el, i) {
      return i * 200
    },
    direction: 'alternate',
  })
  .add(
    {
      targets: INIT_ANIME.solution1,
      translateX: { ...PROPS_ANIME.translateX1 },
      translateY: { ...PROPS_ANIME.translateY2 },
      scale: { ...PROPS_ANIME.scale1 },
      opacity: { ...PROPS_ANIME.opacity1 },
    },
    anime.random(200, 500)
  )
  .add(
    {
      targets: INIT_ANIME.solution2,
      translateX: { ...PROPS_ANIME.translateX3 },
      translateY: { ...PROPS_ANIME.translateY2 },
      scale: { ...PROPS_ANIME.scale1 },
      opacity: { ...PROPS_ANIME.opacity1 },
    },
    anime.random(200, 500)
  )
  .add(
    {
      targets: INIT_ANIME.solution3,
      translateX: { ...PROPS_ANIME.translateX3 },
      translateY: { ...PROPS_ANIME.translateY2 },
      scale: { ...PROPS_ANIME.scale1 },
      opacity: { ...PROPS_ANIME.opacity1 },
    },
    anime.random(200, 500)
  )
  .add(
    {
      targets: INIT_ANIME.solution4,
      translateX: { ...PROPS_ANIME.translateX2 },
      translateY: { ...PROPS_ANIME.translateY2 },
      scale: { ...PROPS_ANIME.scale1 },
      opacity: { ...PROPS_ANIME.opacity1 },
    },
    anime.random(200, 500)
  )
  .add(
    {
      targets: INIT_ANIME.solution5,
      opacity: { ...PROPS_ANIME.opacity1 },
      scale: { ...PROPS_ANIME.scale1 },
      translateY: { ...PROPS_ANIME.translateY1 },
      translateX: { ...PROPS_ANIME.translateX1 },
    },
    anime.random(200, 600)
  )
  .add(
    {
      targets: INIT_ANIME.solution6,
      opacity: { ...PROPS_ANIME.opacity1 },
      scale: { ...PROPS_ANIME.scale1 },
      translateY: { ...PROPS_ANIME.translateY1 },
    },
    anime.random(200, 600)
  )
  .add(
    {
      targets: INIT_ANIME.solution7,
      opacity: { ...PROPS_ANIME.opacity1 },
      scale: { ...PROPS_ANIME.scale1 },
      translateY: { ...PROPS_ANIME.translateY1 },
      translateX: { ...PROPS_ANIME.translateX2 },
    },
    anime.random(200, 600)
  )

let sectionPoints = onSelect('#_vee3w1wqx')
if (sectionPoints !== null && !IS_MOBILE) {
  LENIS_SCROLL_GLOBAL.on('scroll', ({ scroll, limit, progress }) => {
    FUNNEL_ANIME.seek(onScrollAnime(sectionPoints, 1000, 180) * FUNNEL_ANIME.duration)
  })
}
